// extracted by mini-css-extract-plugin
export default {"content":"ServiceInformationRegister_content__r0H4Y"};